import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { Column } from '../../interfaces/table';
import { RouterModule } from '@angular/router';


@Component({
  selector: 'app-table',
  imports: [TableModule, CommonModule, RouterModule],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss'
})
export class TableComponent {

  @Input({ required: true }) cols!: Column[];
  @Input({ required: true }) items!: unknown[];
  @Input() idField!: string;
  @Input() followPath!: string;


  followUrl(id: string) {
    return this.followPath + id;
  }
}
